import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectRenewMode, selectCategoriesSelected } from '../redux/selectors/selectedCategoriesSelector';

/**
 * @returns {boolean} If there is any category selected on the Categories page.
 */
function useIsAnyCategorySelected() {
  const renewMode = useSelector(selectRenewMode);
  const selectedCategories = useSelector(selectCategoriesSelected);
  if (renewMode === 'selected' && selectedCategories.length === 0) return true;
  return false;
}

/**
 * @returns {boolean} If the next button should be disabled for the current screen.
 */
export default function useIsNextButtonDisabled() {
  const location = useLocation();

  const selectedCategories = useIsAnyCategorySelected();

  switch (location.pathname) {
    case '/categories':
      return selectedCategories;
    default: return false;
  }
}
